import { Component, computed, input, output, signal } from '@angular/core';
import { KENDO_BUTTON } from '@progress/kendo-angular-buttons';
import { DialogConfirmSharedComponent } from '@unity/shared/composed/dialog-confirm-shared/dialog-confirm-shared.component';
import { QuickActionProps } from '@unity/utils/types';
import { ActionSharedComponent } from '../action-shared/action-shared.component';

@Component({
  selector: 'unity-action-delete-shared',
  standalone: true,
  imports: [KENDO_BUTTON, DialogConfirmSharedComponent, ActionSharedComponent],
  templateUrl: './action-delete-shared.component.html',
  styleUrl: './action-delete-shared.component.scss',
})
export class ActionDeleteSharedComponent {
  protected readonly $showConfirmDialog = signal(false);

  protected readonly $action = computed<QuickActionProps>(() => {
    const buttonText = this.$buttonText();
    return {
      actionName: buttonText,
      description: buttonText,
      icon: 'xCircleIcon',
    };
  });
  public readonly $disabled = input.required<boolean>({ alias: 'disabled' });
  public readonly $buttonText = input.required<string>({ alias: 'buttonText' });
  public readonly $confirmationMessage = input.required<string>({ alias: 'confirmationMessage' });
  public readonly $confirmationTitle = input.required<string>({ alias: 'confirmationTitle' });

  public readonly deleteEvent = output();

  protected onClickDelete() {
    this.$showConfirmDialog.set(true);
  }

  protected onConfirmDelete() {
    this.deleteEvent.emit();
  }

  protected onConfirmClose() {
    this.$showConfirmDialog.set(false);
  }
}
